export default "__VITE_ASSET__DOqStf5S__"